import * as React from "react";
import { connect } from "react-redux";
import Modal from "../Modal";
import { postAddress } from '../../pages/api';
import globalAction from '../../actions/global';

class AddressModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            receivedName: '',
            receivedPhone: '',
            receivedAddress: '',
            
            receivedNameErr: '',
            receivedPhoneErr: '',
            receivedAddressErr: '',
            isLoading: false,
        }
    }
    onReceivedNameChange(e) {
        this.setState({receivedName: e.target.value, receivedNameErr: ''});
    }
    onreceivedPhoneChange(e) {
        this.setState({receivedPhone: e.target.value, receivedPhoneErr: ''});
    }
    onReceivedAddressChange(e) {
        this.setState({receivedAddress: e.target.value, receivedAddressErr: ''});
    }
    checkReceiveForm() {
        const ptn = /^1[3456789]\d{9}$/;
        const { receivedName, receivedPhone, receivedAddress } = this.state;
        if (!receivedName) {
            this.setState({receivedNameErr: '请输入收件人姓名'});
            return;
        }
        if (!ptn.test(receivedPhone)) {
            this.setState({receivedPhoneErr: '请输入正确的手机号码'});
            return;
        }
        if (!receivedAddress) {
            this.setState({receivedAddressErr: '请输入详细地址'});
            return;
        }
        this.submitReceiveForm();
    }
    async submitReceiveForm() {
        const { setAddress, drawRecordId } = this.props;
        const { receivedName, receivedPhone, receivedAddress, isLoading } = this.state;       

        if (!isLoading) {
            this.setState({isLoading: true});
            const {result} = await new postAddress({
                name: receivedName,
                phone: receivedPhone,
                address: receivedAddress,
                drawRecordId: drawRecordId
            }).fetch();
            this.setState({isLoading: true});
            if (result.code === 200) {
                setAddress({
                    name: receivedName,
                    phone: receivedPhone,
                    address: receivedAddress
                });
            }
        }
        
    }
    __onClose() {
        const {onClose} = this.props;
        onClose();
    }
    render() {
        const {isOpen, address} = this.props;
        const {receivedName, receivedAddress, receivedPhone, receivedNameErr, receivedPhoneErr, receivedAddressErr} = this.state;
        return (
            <Modal title="我的收货地址" isOpen={isOpen} className="w-modal-address" onClose={this.__onClose.bind(this)}>
                <div className="w-modal-addr">
                    <div className="w-modal-confirm-bd">
                            {
                                address && address.name ?
                                    <div className="info-form">
                                        <div className="form-item f-clear">
                                            <div className="form-label">您的姓名</div>
                                            <div className="form-control-text">{address.name}</div>
                                        </div>
                                        <div className="form-item f-clear">
                                            <div className="form-label">手机号码</div>
                                            <div className="form-control-text">{address.phone}</div>
                                        </div>
                                        <div className="form-item f-clear">
                                            <div className="form-label">详细地址</div>
                                            <div className="form-control-text">{address.address}</div>
                                        </div>
                                    </div>
                                    :
                                    <div className="info-form">
                                        <div className="form-item f-clear">
                                            <div className="form-label">姓名</div>
                                            <div className="form-control">
                                                <input type="text" name="receivedName" value={receivedName} onChange={this.onReceivedNameChange.bind(this)}/>
                                                {
                                                    receivedNameErr && <div className="form-explain">{receivedNameErr}</div>
                                                }
                                            </div>
                                        </div>
                                        <div className="form-item f-clear">
                                            <div className="form-label">手机号码</div>
                                            <div className="form-control">
                                                <input type="text" name="receivedPhone" value={receivedPhone} onChange={this.onreceivedPhoneChange.bind(this)}/>
                                                {
                                                    receivedPhoneErr && <div className="form-explain">{receivedPhoneErr}</div>
                                                }
                                            </div>
                                        </div>
                                        <div className="form-item f-clear">
                                            <div className="form-label">详细地址</div>
                                            <div className="form-control">
                                                <textarea value={receivedAddress} onChange={this.onReceivedAddressChange.bind(this)}></textarea>
                                                {
                                                    receivedAddressErr && <div className="form-explain">{receivedAddressErr}</div>
                                                }
                                            </div>
                                        </div>
                                        <div className="form-item f-clear">
                                            <div className="form-label"></div>
                                            <div className="form-control">
                                                <button className="w-button" onClick={this.checkReceiveForm.bind(this)}>提交</button>
                                            </div>
                                        </div>
                                    </div>
                            }
                        </div>
                </div>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        address: state.global.address || {},
        drawRecordId: state.global.phoneDrawRecordId
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setAddress(addr) {
            dispatch(globalAction.setAddress(addr));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddressModal);
